import type { Route } from '#/global'
import type { RouteRecordRaw } from 'vue-router'
import generatedRoutes from 'virtual:generated-pages'
import { setupLayouts } from 'virtual:meta-layouts'
// import MultilevelMenuExample from './modules/multilevel.menu.example'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home', // ✅ 重定向根路径到 /home
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: 'app.login',
    },
  },
  {
    path: '/login/risk-review',
    name: 'loginRiskReview',
    component: () => import('@/views/login-risk-review.vue'),
    meta: {
      title: 'login.riskReview.pageTitle',
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: 'app.notFound',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/home',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: () => useSettingsStore().settings.home.title,
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: () => useSettingsStore().settings.home.title,
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile.vue'),
        meta: {
          title: 'app.profile',
          icon: 'i-ant-design:user-outlined',
          breadcrumb: true,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: 'app.reload',
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/examples',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: 'examples.title',
      icon: 'i-ep:menu',
      order: 100, // 排序靠后，作为示例模块
    },
    children: [
      {
        path: 'vxe_table',
        component: () => import('@/views/examples/vxe_table/page.vue'),
        meta: {
          title: 'examples.vxeTable.title',
          icon: 'i-ep:table',
          menu: true,
        },
      },
      {
        path: 'vxe_table_grid',
        component: () => import('@/views/examples/vxe_table/page_grid.vue'),
        meta: {
          title: 'examples.vxeTableGrid.title',
          icon: 'i-ep:table',
          menu: true,
        },
      },
    ],
  },
  // 公共路由 -- 数据共享
  {
    path: '/me/data_sharing',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: 'toolbar.dataSharing',
      breadcrumb: true,
    },
    children: [
      {
        path: '',
        name: 'routing-data-sharing',
        component: () => import('@/views/data_sharing/index.vue'),
        meta: {
          title: 'toolbar.dataSharing',
          icon: 'i-ep:share',
          breadcrumb: true,
        },
      },
    ],
  },
  // {
  //   path: '/reporting/daily/detail',
  //   component: () => import('@/layouts/index.vue'),
  //   meta: {
  //     title: 'reporting.title',
  //     icon: 'i-ep:menu',
  //     order: 100, // 排序靠后，作为示例模块
  //   },
  //   children: [
  //     {
  //       path: 'ad_items/:personId/:date',
  //       name: 'routing-daily-report-ad-items',
  //       component: () => import('@/views/reporting/daily/detail/ad_items/page.vue'),
  //       meta: {
  //         title: 'app.reporting.daily.adItems.pageTitle',
  //         icon: 'i-ep:table',
  //         menu: true,
  //       },
  //     },
  //     // src\views\reporting\daily\detail\order_items\page.vue
  //     {
  //       path: 'order_items/:personId/:date',
  //       name: 'routing-daily-report-order-items',
  //       component: () => import('@/views/reporting/daily/detail/order_items/page.vue'),
  //       meta: {
  //         title: 'app.reporting.orderItems.pageTitle',
  //         icon: 'i-ep:table',
  //         menu: true,
  //       },
  //     },
  //   ],
  // },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
  {
    meta: {
      title: 'app.demo',
      icon: 'i-uim:box',
    },
    children: [
      // MultilevelMenuExample,
    ],
  },
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  asyncRoutes,
  asyncRoutesByFilesystem,
  constantRoutes,
  constantRoutesByFilesystem,
  systemRoutes,
}
